import { SAMPLE_DEMO_EMPLOYEES } from './fixtures/sampleEmployees';
import { DEMO_EMPLOYEE_SOURCE } from './constants';
import { ROLE_PERMISSIONS } from '../company-management/constants/permissions';

const buildDemoEmail = (index, companyId) => {
  const slug = String(companyId || 'company').slice(0, 8);
  return `demo.staff.${String(index + 1).padStart(2, '0')}.${slug}@demo.neatschedule.local`;
};

export function buildDemoEmployeePayloads({
  companyId,
  ownerId,
  count = 12,
  demoBatchId,
}) {
  const safeCount = Math.max(1, Math.min(count, SAMPLE_DEMO_EMPLOYEES.length));

  return SAMPLE_DEMO_EMPLOYEES.slice(0, safeCount).map((template, index) => {
    const role = template.role === 'manager' ? 'manager' : 'employee';

    return {
      firstName: template.firstName,
      lastName: template.lastName,
      title: template.title,
      email: buildDemoEmail(index, companyId),
      phone: `55501${String(2000 + index).slice(-4)}`,
      role,
      companyId,
      ownerId,
      status: 'active',
      permissions: ROLE_PERMISSIONS[role] || ROLE_PERMISSIONS.employee,
      source: DEMO_EMPLOYEE_SOURCE,
      demoBatchId,
      isDemoAccount: true,
    };
  });
}
